package system_component_style

import androidx.compose.runtime.Composable
import androidx.compose.ui.graphics.Color
import kotlinx.browser.document
import org.w3c.dom.HTMLMetaElement

actual class SystemStyle actual constructor() {
    @Composable
    actual fun darkStatusBarIcons(boolean: Boolean) {}
    actual fun statusBarColor(color: Color) {
        val meta = document.querySelector("meta[name=theme-color]") as? HTMLMetaElement
            ?: document.createElement("meta").apply {
                setAttribute("name", "theme-color")
                document.head?.appendChild(this)
            } as HTMLMetaElement

        meta.content = colorToCssRgba(color)
    }

    private fun colorToCssRgba(color: Color): String {
        val r = (color.red * 255).toInt().coerceIn(0, 255)
        val g = (color.green * 255).toInt().coerceIn(0, 255)
        val b = (color.blue * 255).toInt().coerceIn(0, 255)
        val a = color.alpha.coerceIn(0f, 1f)
        return "rgba($r, $g, $b, $a)"
    }
}